<template>
    <div class="newsletter">
        <div class="content">
            <b-row>
                <b-col cols="12" md="7">
                    <h3>Tú también <span>comienza hoy</span> a formar parte del mundo profesional de las ventas</h3>
                    <p>Suscribirte aquí a mi newsletter para obtener más información</p>
                </b-col>
                <b-col cols="12" md="5">
                    <!-- Begin Constant Contact Inline Form Code -->
                        <div class="ctct-inline-form" data-form-id="b61472d7-c0f9-4c05-8864-f6ce19f44f60"></div>
                    <!-- End Constant Contact Inline Form Code -->
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            setTimeout(function(){
                /* PROGRAMMATICALLY INJECT JS HERE */
                var recaptchaJs = document.createElement('script');
                recaptchaJs.setAttribute('src','https://static.ctctcdn.com/js/signup-form-widget/current/signup-form-widget.min.js');
                document.head.appendChild(recaptchaJs);
            }, 3000);
        }
    }
</script>

<style scoped>
    .newsletter{
        padding: 100px 0;
    }
    h3{
        max-width: 650px;
    }
    h3, h3 span{
        text-transform: none;
    }

    @media screen and (max-width: 767px){
        .newsletter{
            padding: 80px 0;
        }
    }
</style>

<style>
    .ctct-form-embed.form_0 .ctct-form-defaults{
        background-color: transparent!important;
        padding: 0!important;
    }
    .ctct-form-embed.form_0 .ctct-form-defaults .ctct-form-text, .ctct-form-embed.form_0 .ctct-form-custom .ctct-form-label, .ctct-form-embed.form_0 .ctct-form-custom .ctct-form-listname, .ctct-form-embed.form_0 .ctct-form-custom .ctct-form-lists-legend, .ctct-form-embed.form_0 .ctct-form-custom .ctct-form-date-slash, .ctct-form-embed.form_0 .ctct-form-defaults .ctct-gdpr-text, .ctct-form-embed.form_0 .ctct-form-defaults .ctct-gdpr-text .ctct-form-footer-link, .ctct-form-embed.form_0 .ctct-form-defaults .ctct-gdpr-text .ctct-form-footer-privacy-link{
        color: #171717!important;
    }
    div.ctct-form-embed form.ctct-form-custom input.ctct-form-element{
        background-color: transparent!important;
        border-radius: inherit!important;
        color: #171717!important;
        height: auto!important;
        padding: 5px 10px!important;
        outline: none!important;
    }
    div.ctct-form-embed div.ctct-form-defaults p.ctct-form-footer{
        display: none!important;
    }
    .ctct-gdpr-text{
        display: none!important;
    }
    .ctct-form-embed.form_0 .ctct-form-custom .ctct-form-button{
        background-color: transparent!important;
        border-color: #EC4802!important;
        border-radius: inherit!important;
        color: #EC4802!important;
        width: auto;
        padding: 5px 15px 10px 15px;
        font-size: 11pt;
    }
    .ctct-form-embed.form_0 .ctct-form-custom .ctct-form-button::after{
        content: url('../assets/img/icn_send.svg');
        display: inline-block;
        margin-top: 5px;
        margin-left: 30px;
    }
    
    .ctct-form-label{
       visibility: hidden;
    }
    .ctct-form-label::before{
        visibility: visible;
    }
    .ctct-form-label::after{
        visibility: visible;
        position: absolute;
        left: 0;
    }
    #email_address_label_0::after{
        content: 'Correo electrónico';
    }
    #first_name_label_0::after{
        content: 'Nombre';
    }
    #last_name_label_0::after{
        content: 'Apellido';
    }
</style>


// WEBPACK FOOTER //
// src/components/Newsletter.vue